import { qaData } from '~/src/features/mania/data';

import * as ST from './styled';

const QuestionsBlock = (): JSX.Element => {
    return (
        <ST.QaContainer>
            <ST.QaTitle>Частые вопросы</ST.QaTitle>
            <ST.QaWrapper>
                {qaData.map(qa => (
                    <ST.QaAccordion
                        key={qa.id}
                        title={qa.question}
                        itemScope
                        itemProp='mainEntity'
                        itemType='https://schema.org/Question'
                        data-test='mania-qa'
                    >
                        <ST.QaAnswer>{qa.answer}</ST.QaAnswer>
                    </ST.QaAccordion>
                ))}
            </ST.QaWrapper>
        </ST.QaContainer>
    );
};

export default QuestionsBlock;
